/* istanbul ignore file */
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEarth } from '@fortawesome/pro-regular-svg-icons';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import ModalComponent from '../../../layout/Modals/ModalComponent/ModalComponent';
import { connectModalContainerContextToComponent } from '../../../../contexts/ModalContext/ModalContext';

import { CrudStatus } from '../../../../utility/types/CrudStatus';
import {
  selectLocationUpdateStatus,
  selectSingleDevice,
  updateDeviceLocation,
} from '../../../../redux/slices/singleDeviceSlice/singleDeviceSlice';

function EditLocationModal({ setModalJSX, currentLocation = '' }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(true);
  const [error, setError] = useState('');
  const [location, setLocation] = useState(currentLocation);
  const [submitting, setSubmitting] = useState(false);

  const locationUpdateStatus = useSelector(selectLocationUpdateStatus);
  const device = useSelector(selectSingleDevice);

  const closeModalHandler = () => {
    setShow(false);
    setModalJSX((<></>));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      await dispatch(updateDeviceLocation({
        deviceId: device.general.id,
        location: location.trim(),
      })).unwrap();

      closeModalHandler();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error updating location:', err);
      setError('Unexpected error updating location. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalComponent
      showConfirmCallToAction
      show={show}
      close={closeModalHandler}
      confirmButtonText="Save"
      confirmButtonAction={handleSubmit}
      isBtnDisabled={submitting || locationUpdateStatus === CrudStatus.PENDING}
    >
      <Modal.Header closeButton={false}>
        <div className="w-100 d-flex justify-content-between align-items-center">
          <Modal.Title>Update Location</Modal.Title>
          <a href="/devices/device-map" className="text-muted">
            Go to Map
            {' '}
            <FontAwesomeIcon icon={faEarth} />
          </a>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="px-3">
          {error && (
            <div className="row">
              <div className="col">
                <ErrorBanner onCloseError={() => setError('')}>
                  {error}
                </ErrorBanner>
              </div>
            </div>
          )}
          <p>
            You can plot your devices on the map by street address, city, state,
            country, coordinates or any other location.
          </p>
          <div className="form-group row">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label
              htmlFor="locationInput"
              className="col-sm-2 col-form-label text-right"
            >
              Location
            </label>
            <div className="col-sm-10">
              <input
                type="text"
                className="form-control"
                id="locationInput"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                disabled={locationUpdateStatus === CrudStatus.PENDING}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </ModalComponent>
  );
}

EditLocationModal.propTypes = {
  setModalJSX: PropTypes.func.isRequired,
  currentLocation: PropTypes.string,
};

EditLocationModal.defaultProps = {
  currentLocation: '',
};

export { EditLocationModal };
export default connectModalContainerContextToComponent(EditLocationModal);
